module.exports = __webpack_public_path__ + "static/connect-3f22b792a98b164edc3ce4ebb643b18f.svg";